import React, { Component } from "react";
import { Map, GoogleApiWrapper, Marker, InfoWindow , Polyline} from 'google-maps-react';
import firebase from "firebase/app";
import 'firebase/firestore';

const mapStyles = {
  width: '100%',
  height: '100%'
};

class Localiza extends Component {
  constructor(props) {
    console.log(props);
    console.log(props);

    super(props);
    this.state = {
      lista: props.list,
       latitude:props.list.latitude, longitude:props.list.longitude,
        showingInfoWindow: true,  // Hides or shows the InfoWindow
        activeMarker: {},          // Shows the active marker upon click
        selectedPlace: {} 
    };
  

      //this.setState({latitude:listaveiculos1.latitude,: listaveiculos1.longitude, datahora:listaveiculos1.datahora})
          

        
    }
   


    onMarkerClick = (props, marker, e) =>
  this.setState({
    selectedPlace: props,
    activeMarker: marker,
    showingInfoWindow: true
  });

onClose = props => {
  if (this.state.showingInfoWindow) {
    this.setState({
      showingInfoWindow: false,
      activeMarker: null
    });
  }
};

    
    /*<Marker
          
    position={{ lat: this.state.latitude, lng: this.state.longitude }}
  
  />*/



  render() {
    return (
      <div>
        <Map
          google={this.props.google}
          zoom={17}
          style={mapStyles}
       
          initialCenter={{
            lat: this.state.latitude,
            lng: this.state.longitude,
          }}

          
        >

<Marker onClick={this.onMarkerClick} name={'Current Location'}
          coordinate={this.state.lista} />
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}
            onClose={this.onClose}
          ></InfoWindow>
          
        </Map>
        
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyA0RbxlQeRjG7ZPfUSz1e8KV4oWzqm8Ye8'
})(Localiza);

/*
<Polyline 
      options={{
        strokeColor: "red",
        strokeOpacity: 0.75,
        strokeWeight: 2,
        icons: [
            {
                // icon: lineSymbol,
                offset: "0",
                repeat: "20px"
            }
        ]}} 
      path={this.state.lista}
    />

{this.state.lista.map(marker => (
    <Marker
    {...marker}
    onRightClick={() => this.props.onMarkerRightClick(marker)}
  />
  ))}

<Marker onClick={this.onMarkerClick} name={'Current Location'}
          coordinate={this.state.lista} />
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}
            onClose={this.onClose}
          ></InfoWindow>
         

*/